import FlexPane from './_flex-pane.js'
import TabbedPane from './_tabbed-pane.js'
import Text from './_text.js'
import BetslipControllerView from './_betslip-controller-view.js'
import YourBetsController from './_your-bets-controller.js'

export default {
  name: 'BettingCenterView',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexGrow: 0,
        },
      },
    },
    tabs: {
      configSet: TabbedPane,
      configValues: {
        tabButtons: {
          selectableButton: {
            unselected: {
              style: {
                base: {
                  flexGrow: 0,
                  height: '40px',
                  padding: '0 8px',
                  flexBasis: '50%',
                  whiteSpace: 'normal',
                  alignItems: 'center',
                  textAlign: 'center',
                },
              },
            },
            selected: {
              style: {
                base: {
                  flexGrow: 0,
                  height: '40px',
                  padding: '0 8px',
                  flexBasis: '50%',
                  whiteSpace: 'normal',
                  alignItems: 'center',
                  textAlign: 'center',
                },
              },
            },
          },
        },
      },
    },
    tabLabel: {
      configSet: Text,
      configValues: {
        truncate: true,
      },
    },
    selectionsCount: {
      hidden: false,
      displayWhenEmpty: true,
    },
    openBetsCount: {
      hidden: true,
      displayWhenEmpty: true,
    },
    betslip: {
      configSet: BetslipControllerView,
      configValues: {},
    },
    yourBets: {
      configSet: YourBetsController,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
